<div class="flex flex-row items-center gap-2" *ngIf="date">
  <flow-button theme="secondary" variation="outline" (onClick)="currentMonth()">
    {{ 'book.today' | translate }}
  </flow-button>
  <div class="flex flex-row">
    <flow-button theme="light" (onClick)="prevMonth()">
      <app-icon stroke="#202020" fill="none" iconName="chevron-left" size="md"></app-icon>
    </flow-button>
    <flow-button theme="light" (onClick)="nextMonth()">
      <app-icon stroke="#202020" fill="none" iconName="chevron-right" size="md"></app-icon>
    </flow-button>
  </div>
  <div class="flex flex-col">
    <p class="p-0 m-0">{{ 'global.month' | translate}}</p>
    <h3 class="p-0 m-0 font-bold leading-4">{{ monthTranslationKey | translate }} {{year}}</h3>
  </div>
</div>
